import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import HomeRoot from './HomeRoot';
import HomeAdmin from './HomeAdmin';

const Home = () => {
	const user = useSelector(state => state.auth.user);

	return (
		<div>
			{user.role === 'root' && <HomeRoot/>}
			{user.role === 'admin' && <HomeAdmin user={user}/>}
			{user.role === 'agent' && <Navigate replace to='/cabinet/active'/>}
			{user.role === 'exhibitor' && <Navigate replace to='/cabinet/active'/>}
		</div>
	);
};

export default Home;
